import imagesLoaded from 'imagesloaded';
import loadProgress from './preloader.js';


export function preloader() {
	let imgLoad = imagesLoaded('body', { background: true });
	imgLoad.on('progress', () => loadProgress(imgLoad.images.length));
}

// export function preloader() {
// 	if ($('.img_load').length === 0) {
// 		console.log(true);
// 		loadProgress();
// 	} else {
// 		$('.img_load').imagesLoaded({ background: true })
// 			.progress((instance, image) => {
// 				loadProgress();
// 		});
// 	}
// }
